import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Snackbar as MUISnackbar } from '@mui/material';
import { t } from 'i18next';
import React, { SyntheticEvent } from 'react';

const AUTO_HIDE_DURATION = 5000;
interface SnackbarProps {
  message: string;
}

const Snackbar = ({ message }: SnackbarProps): JSX.Element => {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (e: SyntheticEvent<any>) => {
    e.preventDefault();
    handleClose();
  };

  return (
    <MUISnackbar
      TransitionProps={{
        onExited: handleClose,
      }}
      action={[
        <IconButton
          aria-label={t('form.close')}
          color="inherit"
          href="#"
          key="close"
          title={t('form.close')}
          onClick={handleClick}
        >
          <CloseIcon />
        </IconButton>,
      ]}
      autoHideDuration={AUTO_HIDE_DURATION}
      data-testid="current-snackbar"
      message={message}
      open={open}
      onClose={handleClose}
    />
  );
};

export default Snackbar;
